export * from './roof-type-9.component';